import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/core/models/user.model';
import { UserType } from 'src/app/core/models/userType.models';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})

/**
 * Dashboard Component
 */
export class UserComponent implements OnInit {
  term: any;
  users: User[];
  userType: UserType;
 
  toDisplay = true; 

  addEditMode: any;
  userAddEditFormGroup: FormGroup;

  userTypes = [
    {key: UserType.INTERNAL, value: "INTERNAL"},
    {key: UserType.TECH, value: "TECH"},
    {key: UserType.COLLECTOR, value: "COLLECTOR"},
  ]
  

  constructor(private userService: UserService, private modalService: NgbModal, private tastr: ToastrService) {
  }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'User', active: true }];
    await this.refresh();
  }

  async refresh() {
    const userList = await this.userService.getAll();
    this.users = userList;
  }

  get username() {
    return this.userAddEditFormGroup.controls['username'];
  }

  get firstName() {
    return this.userAddEditFormGroup.controls['firstName'];
  }

  get lastName() {
    return this.userAddEditFormGroup.controls['lastName'];
  }

  get primaryEmail() {
    return this.userAddEditFormGroup.controls['primaryEmail'];    
  }

  

  onIncompleteSubmit() {
    alert('failed')
  }

  async onChange() {
    console.log("onChange() called", this.userAddEditFormGroup.value)
  }


  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.userAddEditFormGroup = new FormGroup({
      username: new FormControl<string>('', [Validators.required, Validators.minLength(4)]),
      firstName: new FormControl<string>('',[Validators.required]),
      lastName: new FormControl<string>('', [Validators.required]),
      primaryEmail: new FormControl<string>('', [Validators.required]),
      userType: new FormControl<UserType>(UserType.INTERNAL),
    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, userAddEditFormGroup: this.userAddEditFormGroup.value});
      if(results=="Save click") {
        const {user, errors} = await this.userService.create({...this.userAddEditFormGroup.value});
        if(errors) {
          errors?.forEach(msg => this.tastr.error(msg?.toString()))
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onEdit(user: User, modal: unknown) {
    this.addEditMode = "Edit";
    this.userAddEditFormGroup = new FormGroup({
      username: new FormControl<string>(user.username, [Validators.required]),
      firstName: new FormControl<string>(user.firstName, [Validators.required]),
      lastName: new FormControl<string>(user.lastName, [Validators.required]),
      primaryEmail: new FormControl<string>(user.primaryEmail, [Validators.required]),
      userType: new FormControl<UserType>(user.userType),

    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, userAddEditFormGroup: this.userAddEditFormGroup.value});
      if(results=="Save click") {
        const updatedUser = await this.userService.update(user.id, this.userAddEditFormGroup.value);
        if(updatedUser != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onDelete(user: User) {
    await this.userService.delete(user.id);
    this.toDisplay = !this.toDisplay;
    this.refresh();
  }
  
  async onCheckBoxChanged(event: any, user: User) {
    const newEnabledState = event?.target?.checked;
    
    if(user.enabled != newEnabledState) {
      await this.userService.setEnabled(user.id, newEnabledState);
    }
    this.refresh();
  }
  
  async onPrimaryEmailChanged(event: any, user: User) {
    const newPrimaryEmail = event?.target?.value;
    await this.userService.changePrimaryEmail(user.id, newPrimaryEmail);
    this.refresh();
  }
  
  async onResetPassword(user: User) {
    await this.userService.resetPassword(user.id);
    this.refresh();
    this.tastr.success('Password Reset sent.');
  }
  
}
